/** The user's length unit (metric / imperial preference) for printed values: dimensions, scale bars, legends, elevations. */

import type { PrintLengthUnit } from 'shared-types';
import { useUnitPreference } from '../Properties/integration/UserSettingsIntegration';

export function usePrintLengthUnit(): PrintLengthUnit {
  return useUnitPreference().isFeet ? 'ft' : 'm';
}
